import { relations } from 'drizzle-orm'
import { pgEnum, pgTable } from 'drizzle-orm/pg-core'
import { index } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { customers } from './customer'
import { users } from './user'

// Member role enum
export const memberRoleEnum = pgEnum('member_role', ['owner', 'member'])

export const customerMembers = pgTable(
  'customer_members',
  {
    ...getBaseFields(),
    customerId: getIdReference(() => customers.id),
    userId: getIdReference(() => users.id),
    role: memberRoleEnum().notNull().default('member'),
    joinedAt: getTimestampWithTimezone().notNull().defaultNow(),
  },
  (table) => [
    ...getBaseIndexes('customer_members', table),
    index('customer_members_customer_id_idx').on(table.customerId),
    index('customer_members_user_id_idx').on(table.userId),
  ],
)

export const customerMembersRelations = relations(
  customerMembers,
  ({ one }) => ({
    customer: one(customers, {
      fields: [customerMembers.customerId],
      references: [customers.id],
    }),
    user: one(users, {
      fields: [customerMembers.userId],
      references: [users.id],
    }),
  }),
)
